module.exports = __webpack_public_path__ + "static/img/GalaxyTabA.ef1fb030.png";